// extracted by css-extract-rspack-plugin
export default {"sidebar":"PullRequestFileTree-module__sidebar__Whxg0hM","FileTreeScrollable":"PullRequestFileTree-module__FileTreeScrollable__LP8rFsV"};